import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import { useFolder } from "src/core/contexts/FolderContext";
import { useDeleteMissionMutation } from "src/core/gql/graphql";
import { IMission } from "src/core/hooks/folder/useFolderMissions";
import { useToast } from "src/core/hooks/use-toast";

export const useDeleteMission = (
  setOpen: (open: boolean) => void,
  mission: IMission | null,
  setMissionToEdit: (mission: IMission | null) => void
) => {
  const [deleteMission, { loading }] = useDeleteMissionMutation();
  const { toast } = useToast();
  const { refetch } = useFolder();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = useCallback(async () => {
    try {
      setIsLoading(true);
      if (!mission) {
        throw new Error("Mission not found");
      }

      await deleteMission({ variables: { missionId: mission.id } });
      await refetch();

      toast({
        description: t("deleteMission.modal.success"),
      });
    } catch (error) {
      console.error("useDeleteMission::error", error);
      toast({
        description: t("deleteMission.modal.error"),
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
      setOpen(false);
      setMissionToEdit(null);
    }
  }, [mission, deleteMission, refetch, toast, t, setOpen, setMissionToEdit]);

  return { handleDelete, loading: isLoading || loading };
};
